export { default } from './DetailedCarPlaceholder';
